export default __webpack_public_path__ + "static/media/Quantity2.dd992fa3.svg";